import { apiClient } from '@/lib/apiClient';

const getErrorMessage = (error, fallback) => {
  const detail = error?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || JSON.stringify(item)).join(' | ');
  }
  return fallback;
};

export const customerApi = {
  getProfile: async () => {
    const { data, error } = await apiClient.GET('/api/v1/auth/me');
    if (error || !data) {
      throw new Error(getErrorMessage(error, 'خطا در دریافت اطلاعات پروفایل'));
    }
    return data;
  },

  updateProfile: async (body) => {
    const { data, error } = await apiClient.PATCH('/api/v1/auth/me', { body });
    if (error || !data) {
      throw new Error(getErrorMessage(error, 'ذخیره پروفایل با خطا مواجه شد'));
    }
    return data;
  },
};
